module.exports = __webpack_public_path__ + "media/images/web/landings/students/s5-b9de63b2e3c3c6a7d5283ae4d7085843.jpg";